import { RemissionService } from './../../services/remission.service';
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Subscription, forkJoin } from "rxjs";
import { BOFilter } from "../../models/BOFilter";
import { Router } from "@angular/router";
import { RemissionComponent } from "./remission.component";
import { BORemission } from "../../models/BORemission.model";
import { PdfService } from "../../services/pdf.service";
import { DatePipe } from "@angular/common";
import { ClinicHistoryService } from '../../services/clinicHistory.service';
import { EpsService } from '../../services/eps.service';
import { PersonService } from '../../services/person.service';
import { PatientInformationService } from '../../services/patientInformation.service';
import { BOClinicHistory } from '../../models/BOClinicHistory.model';
import { BOEps } from '../../models/BOEps.model';
import { BOPatientInformation } from '../../models/BOPatientInformation.model';
import { BOPerson } from '../../models/BOPerson.model';
import { BOCompany } from '../../models/BOCompany.model';
import { CompanyService } from '../../services/company.service';
import { BOItem } from '../../models/BOItem.model';
import { GenderIdentityService } from '../../services/genderIdentity.service';
import { IdTypeService } from '../../services/idType.service';
import { SpinnerService } from '../../services/spinner.service';
import { DiagnosticNovoService } from '../../services/diagnosticNovo.service';

@Component({
  selector: 'remission-history',
  templateUrl: './remissionHistory.component.html',
  styleUrls: ['./remissionHistory.component.css']
})
export class RemissionHistoryComponent implements OnInit, OnDestroy {
  @ViewChild('remissionModal', {static:true}) remissionModal: RemissionComponent;


  remissionList:BORemission[]=[];
  //quoteListShort:BOToothQuote[]=[];
  remission:BORemission=new BORemission();
  totalPrice:number=0;
  userName:string="";

  ch:BOClinicHistory= new BOClinicHistory();
  patientInformation: BOPatientInformation= new BOPatientInformation();
  patient:BOPerson= new BOPerson();
  company:BOCompany=new BOCompany();
  epsList                   : BOEps []=[];

  genderIdentityList        : BOItem[]=[];
  idTypeList                : BOItem[]=[];




  busy:Subscription;
  busyCh: Subscription;
  busyPt: Subscription;
  remissionFilter:string="";


  constructor( private _remissionService: RemissionService,
              private _epsService: EpsService,
              private _clinicHistoryService: ClinicHistoryService,
              private _patientInformationService: PatientInformationService,
              private _personService: PersonService,
              private _companyService: CompanyService,
              private _genderIdentityService: GenderIdentityService,
              private _idTypeService        : IdTypeService,
              private _router:Router,
              private _toast:ToastrService,
              private _spinnerService       : SpinnerService,
              private _diagnosticNovoService : DiagnosticNovoService
   ) { }


  ngOnInit(): void {
        const filterInput: BOFilter = {filter: this.remissionFilter}
      this.busy=this._remissionService.getAll(filterInput).subscribe(data=>{
      console.log('in ngOnInit of remissionhistory,  data is', data);

      this.remissionList=data;
      //this.quoteListShort=[...this.quoteList];
      console.log('in ngOnInit of remissionHistory,  this.remissionList is:', this.remissionList);
    });
  }


    getAll()
    {
        console.log('Entra a getAll');
        this.remissionList=[];

        const filterInput: BOFilter = {
            filter: this.remissionFilter.toUpperCase().trim()
        }
        this.busy = this._remissionService.getAll(filterInput)
        .subscribe(data=>{this.remissionList = data;
             //Ric
            if(!data.length) this.remissionFilter= "";

            if(this.remissionList.length>0){
              this._toast.success('Existen registros', 'Registros capturados');
            }

        });

    }

    openRemission(chId:number,docId:string,state:string, remId: number)
    {

      console.log('Entra a openRemission, remissionId es:', remId, ' ch es:', chId, ', docId es:', docId, ' y remId es:', remId);

      this._spinnerService.show();
      this.busyCh= this._personService.getPersonByDocumentIdString(docId).subscribe(data=>{
        this.patient=data;
        console.log("En rH, personService captura esta persona:", data);
      this.busyPt= forkJoin(
      {
        resultClinicHistory : this._clinicHistoryService.getClinicHistory(chId),
        resultEps           : this._epsService.getAll(),
       // resultPerson        : this._personService.getPersonByDocumentIdString(docId),
        resultCompany       : this._companyService.getCompany(),

        resultGenderIdentityList         : this._genderIdentityService.getAll(),
        resultIdTypeService              : this._idTypeService.getAll(),
        resultPatientInformation         : this._patientInformationService.getPatientInformation(this.patient.patientInformationId),
        resultRemission                  : this._remissionService.getRemissionById(remId),
      })
      .subscribe((
        {
          resultClinicHistory,
          resultEps,
          resultPatientInformation,
          resultCompany,

          resultGenderIdentityList,
          resultIdTypeService,
          resultRemission

        }
      )=>{
        this.ch=resultClinicHistory;
        this.epsList=resultEps;
        this.patientInformation=resultPatientInformation;
        this.company=resultCompany;

        this.genderIdentityList=resultGenderIdentityList;
        this.idTypeList=resultIdTypeService;
        this.remission=resultRemission;
        console.log('Remisión enviada es: ', this.remission);
        this.remissionModal.openModal(this.ch, this.epsList,this.patient,this.patientInformation,this.company, state,'history', this.remission);

      });

      })
      //this._spinnerService.hide();

    }


    navigateToQuote(clinicHistoryId:number, personId:number, personName:string, isQuoteWithOdontograma?:boolean,quoteId?: number,)
    {
      console.log("Entra a navigateToQuote");
        this._router.navigate(['/dental-Admins/quote'], {

            state: {
              clinicHistoryId: clinicHistoryId,
              personId: personId,
              userName:personName,
              isQuoteWithOdontograma:isQuoteWithOdontograma,
              action2: 'editToothQuote',  // ← trigger para ejecutar
              toothQuote:quoteId
            }

          });
    }

    ngOnDestroy(): void {
       // this.busy.unsubscribe();
        if (this.busy) {
          this.busy.unsubscribe();
      }

      if (this.busyCh) {
          this.busyCh.unsubscribe();
      }

      if (this.busyPt) {
      this.busyPt.unsubscribe();
      }
  }

}
